import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2ca5796d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2ca5796d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca5796d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ca5796d')) {
      api.createRecord('2ca5796d', component.options)
    } else {
      api.reload('2ca5796d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2ca5796d&scoped=true", function () {
      api.rerender('2ca5796d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/productManage/index.vue"
export default component.exports